import * as Effect from "/npm/effect@3.14.1/Effect/+esm";
import * as FiberRef from "/npm/effect@3.14.1/FiberRef/+esm";
import * as LogLevel from "/npm/effect@3.14.1/LogLevel/+esm";

export const filterLevelOrNever = <A, E, R>(
  level: LogLevel.LogLevel,
  effect: Effect.Effect<A, E, R>
) =>
  Effect.gen(function* () {
    const logLevel = yield* FiberRef.get(FiberRef.currentMinimumLogLevel);
    if (logLevel._tag !== level._tag) return yield* effect;
  });

export const makeNamespacedLogSpan = (prefix: string) => (label: string) =>
  Effect.withLogSpan(`${prefix}:${label}`);
